export const ItemsPagePublish = () => {
    return (
        <>
            <div className="items_boxes_outer">
                <div className="item_box1">
                    <div className="fiter_top">
                        <h3 className="filter_heading">항목 유형</h3>
                        <div className="filter_toolbar">
                            <select className="form-select w-150px">
                                <option>비연동 데이터</option>
                            </select>
                        </div>
                    </div>
                    <ul className="list_items">
                        <li className="active"><a href="#/item-1">출하</a></li>
                        <li className=""><a href="#/item-2">매출</a></li>
                    </ul>
                </div>
                <div className="item_box2">
                    <div className="fiter_top">
                        <h3 className="filter_heading">항목 목록</h3>
                        <div className="filter_toolbar">
                            <button className="btn btn-secondary w-60px">수정</button>
                            <button className="btn btn-dark w-60px">추가</button>
                        </div>
                    </div>
                    <ul className="list_items">
                        <li className="active"><a href="#/item-1">출하</a></li>
                        <li className=""><a href="#/item-2">매출</a></li>
                    </ul>
                </div>
                <div className="item_box3">
                    <div className="fiter_top">
                        <h3 className="filter_heading">항목 상세</h3>
                        <div className="filter_toolbar">
                            <button className="btn btn-outline-dark w-100px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                            <button className="btn btn-secondary w-100px">수정</button>
                        </div>
                    </div>

                    <h5 className="subheading">항목 조회</h5>

                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "7.3%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th>항목</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </td>
                                <td>로열티매출(세금계산서)</td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </td>
                                <td>기타매출</td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </td>
                                <td>로열티매출(세금계산서)</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}